module.exports = __webpack_public_path__ + "static/media/role-photo.b790e63a.jpg";